import { apiClient } from './client';

/**
 * Get course revenue data (ADMIN only — other roles get a 403).
 * @param {string} courseId
 * @returns {{ totalRevenue, byMonth: Array<{ month, amount }>, byMethod: { paycom, click },
 *   paymentCount, averagePayment, pendingCount, pendingAmount, monthlyGrowth }}
 */
export async function getCourseRevenue(courseId) {
  const { data } = await apiClient.get(`/enrollments/courses/${courseId}/revenue`);
  return data;
}

/**
 * Get course payments
 * @param {string} courseId
 * @param {{ page?, limit?, status?, method?: 'PAYCOM'|'CLICK', startDate?, endDate?, sortBy?, sortOrder? }} params
 *   `method` is cast straight to Prisma's `PaymentProvider` enum on the
 *   backend (enrollments.service.ts) — it must be sent uppercase
 *   ('PAYCOM'/'CLICK'), a lowercase value throws a 500.
 */
export async function getCoursePayments(courseId, params = {}) {
  const { data } = await apiClient.get(`/enrollments/courses/${courseId}/payments`, { params });
  return data;
}
